


































import { Component, Prop, Vue } from 'vue-property-decorator';
import {HttpResp, SnsResp, KinesisResp, AzureEventHubResponse} from '@/types/core-push';

@Component
export default class DeliveryResponse extends Vue {
  
  @Prop({ default: () => {},  type: Object}) response!: HttpResp | SnsResp | KinesisResp | AzureEventHubResponse;
  @Prop({ default: "",  type: String}) error!: string;

  get isHttpResp() {
    let httpResp = this.response as HttpResp;
    return httpResp.status !== undefined && httpResp.statusText !== undefined; 
  }

  get httpRespData() {
    let httpResp = this.response as HttpResp;
    return httpResp.data.length < 30 ? httpResp.data : `${httpResp.data.substring(0, 27)}...`;
  }

  get isSnsResp() {
    let snsResp = this.response as SnsResp;
    return snsResp.messageId;
  }

  get isKinesisResp() {
    let kinesisResp = this.response as KinesisResp;
    return kinesisResp.shardId && kinesisResp.seqNumber;
  }

  get isAzureEventHubResp() {
    const azureEventHubResp = this.response as AzureEventHubResponse;
    return azureEventHubResp.statusMessage;
  }
}
